(function() {
	'use strict';

	angular.module('cmsApp').controller('CMSController', CMSController);

	CMSController.$inject = [ '$window', '$timeout', '$cookies', 'CMSService',
			'$state', '$http', '$scope', 'GLOBAL_URL', '$base64', '$uibModal',
			'$stateParams', '$injector', 'Upload', 'authExpiredInterceptor', 'NgTableParams'];

	function CMSController($window, $timeout, $cookies, CMSService, $state,
			$http, $scope, GLOBAL_URL, $base64, $uibModal, $stateParams,
			$injector, Upload, authExpiredInterceptor, NgTableParams) {
		var vm = this;
		var self = $scope;
		self.format = 'dd/MM/yyyy';

		self.dateOptions = {
			minDate : new Date()
		}

		vm.altInputFormats = [ 'M!/d!/yyyy' ];

		vm.openDatePicker = function() {
			vm.popupDateReceipt = true;
		};

		vm.popupDateReceipt = false;

		vm.loadPage = function() {
			CMSService.query({
				uri : 'initPage'
			}, function(result) {
				vm.listCategory = result;
			});
			vm.loadMenu();
		}

		vm.loadMenu = function() {
			CMSService.query({
				uri : 'loadMenu'
			}, function(result) {
				vm.listMenu = result;
			});
		}

		vm.downloadContent = function(documentId) {
			CMSService.get({
				uri : 'loadDocumentEdit',
				documentId : documentId
			}, function(result) {
				if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
					// IE
					// browser
					if (result.content != undefined) {
						var byteCharacters = atob(result.content);
						var byteNumbers = new Array(byteCharacters.length);
						for (var i = 0; i < byteCharacters.length; i++) {
							byteNumbers[i] = byteCharacters.charCodeAt(i);
						}
						var byteArray = new Uint8Array(byteNumbers);
						var blob = new Blob([ byteArray ], {
							type : result.dataType
						});
						window.navigator.msSaveBlob(blob, result.fileName);
					} else {
						var blob = new Blob([ data ], {
							type : result.dataType
						});
						window.navigator.msSaveBlob(blob, result.fileName);
					}
				} else {
					// truong hop file da luu duoi database
					if (result.content != undefined) {
						var byteCharacters = atob(result.content);
						var byteNumbers = new Array(byteCharacters.length);
						for (var i = 0; i < byteCharacters.length; i++) {
							byteNumbers[i] = byteCharacters.charCodeAt(i);
						}
						var byteArray = new Uint8Array(byteNumbers);
						var blob = new Blob([ byteArray ], {
							type : result.dataType
						});
						var url = $window.URL || $window.webkitURL;
						// var url = window.URL;
						var aTag = document.createElement("a");
						aTag.style = "display: none";
						aTag.href = url.createObjectURL(blob);
						aTag.download = result.fileName;
						aTag.click();
					}
				}
			});
		}

		vm.createNew = function() {
			$state.go('createNew');
		}
		var modalInstance = null;
		vm.openPopupDeleteNews = function(documentId) {
			modalInstance = $uibModal.open({
				animation : true,
				templateUrl : GLOBAL_URL
						+ 'partial?uri=admin/layout/deleteNews',
				controller : 'CMSDialogController',
				controllerAs : 'vm',
				size : 'sm',
				resolve : {
					categoryId : function() {
						return documentId;// tranfer data for dialog
					}
				}
			});
			modalInstance.result.then(function(listCategory) {
				/*vm.listCategory = listCategory;*/
				vm.tableParams.page(1);
				vm.tableParams.count(10);
				vm.tableParams.total(0);
				vm.tableParams.reload();
				modalInstance = null;
			}, function() {
			});
		}

		vm.cancel = function() {
			if (modalInstance != null)
				modalInstance.dismiss('cancel');
		}
		
		vm.loadParentCategory = function() {
			CMSService.query({
				uri : 'loadParentCategory'
			}, function(result) {
				vm.listParentMenu = result;
				vm.loadDocumentEdit();
			});
		}

		vm.loadCategory = function(parentMenuId) {
			CMSService.query({
				uri : 'loadCategory',
				parentMenuId : parentMenuId
			}, function(result) {
				vm.listSubMenu = result;
			});
		}
		vm.edit = false;
		vm.loadDocumentEdit = function() {
			if ($stateParams.documentId !== undefined
					&& $stateParams.documentId !== null) {
				var documentId = $base64.decode($stateParams.documentId);
				if (documentId != null) {
					CMSService.get({
						uri : 'loadDocumentEdit',
						documentId : documentId
					}, function(result) {
						vm.category = result;
						if(vm.category.parentMenu !== undefined && vm.category.parentMenu !== null && vm.category.parentMenu !== '') {
							vm.loadCategory(vm.category.parentMenu);
						}
						vm.edit = true;
					});
				}
			}
		}

		vm.loadByCategory = function(menuId) {
			vm.menuId = menuId;
			vm.tableParams.page(1);
			vm.tableParams.count(10);
			vm.tableParams.total(0);
			vm.tableParams.reload();
		}

		vm.removeFileAttach = function(file, errFiles) {
			if (file != undefined && file != null) {
				vm.category.fileName = file.name;
			}
		}

		vm.createNews = function() {
			var data = [];

			data['news'] = new Blob([ JSON.stringify(vm.category) ], {
				type : "application/json"
			});
			if (vm.attachment !== undefined && vm.attachment !== null && vm.attachment !== '') {
				data['file'] = vm.attachment;
				Upload.upload(
						{
							url : GLOBAL_URL + 'api/cms/saveNews?access_token='
									+ authExpiredInterceptor.getToken(),
							data : data
						}).then(function(result) {
					$state.go('category');
				}, function(result) {
					$state.go('category');
				}, function(evt) {
				});
			} else {
				CMSService.post({
					uri : 'save'
				}, vm.category, function() {
					$state.go('category');
				}, function() {
					$state.go('category');
				});
			}
		}
		
		vm.editNews = function(documentId) {
			var uri = null;
    		var number = null;
    		if (documentId) {
    			uri = 'ga/cms/#/createNew/';
    			number = $base64.encode(documentId);
    		}
    		uri = uri.concat(number);
    		$window.open(GLOBAL_URL + uri, '_self')
		}
		
		vm.tableParams = new NgTableParams({
			page: 1,
			count: 20,
			sorting: { makerDate: 'desc' } 
		},
		{
			total: 0,
			counts: [20, 40, 80],
			defaultSort: 'desc',
			getData: function(params) {
	    		var param = {};
	    		param['page'] = params.page();
	    		param['size'] = params.count();
	    		param['sort'] = params.sorting();
	    		param['uri'] = 'spec';
	    		if (vm.menuId !== undefined && vm.menuId !== null && vm.menuId !== '') {
	    			param['menuId'] = vm.menuId;
	    		}
	    		
	    		return CMSService.get(param).$promise.then(function(result) {
	    			params.total(result.totalItems);
					return result.listDocument;
				});
			 }
		});
		
		vm.isNew = function(category) {
			var dateNow = new Date().getTime();
			var createDate = new Date(category.makerDate).getTime();
			var one_hour = 1000 * 60 * 60;
			var difference_ms = dateNow - createDate;
			var hours = difference_ms / one_hour;
			var isNew = false;
			if(hours <= 24 * 15) {
				isNew = true;
			}
			return isNew;
		};
		self.oneAtATime = true;

		$scope.status = {
			    isCustomHeaderOpen: false,
			    isFirstOpen: true,
			    isFirstDisabled: false
			  };

	}
})();
